import { LoadingButton } from "@mui/lab"
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"
import { useEffect, useState } from "react"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"
import Vista from "../../components/Vista"
import { useAlert } from "../../hooks/useAlert"
import Servo from "../../services/servo"

const ManoObra = ({ idOrdenServicio }) => {
  const { showAlert } = useAlert()
  const [servicio, setServicio] = useState(null)
  const [tareas, setTareas] = useState([])
  const [loading, setLoading] = useState(false)

  const cargar = async () => {
    if (!idOrdenServicio) return
    const res = await Servo.get(`tareas-orden-servicio?idOrdenServicio=${idOrdenServicio}&limite=200&expand=manoObra`)
    setTareas(res?.cuerpo?.resultado || [])
  }
  useEffect(() => { cargar() }, [idOrdenServicio])

  const ejecutar = async (accion, body) => {
    setLoading(true)
    try {
    const res = await Servo.post(`tareas-orden-servicio/${accion}`, body, "ordenServicios", false)
    showAlert({ message: res?.cuerpo?.mensaje || "No se pudo completar la operación", severity: res?.cuerpo?.detalle?.estatus === 200 ? "success" : "warning" })
    if (res?.cuerpo?.detalle?.estatus === 200) { setServicio(null); await cargar() }
    } catch (e) { showAlert({ message: "No se pudo guardar el servicio. Intenta nuevamente.", severity: "error" }) }
    finally { setLoading(false) }
  }
  const crear = () => {
    if (!servicio || !idOrdenServicio) return showAlert({ message: "Seleccione un servicio y guarde primero la orden", severity: "warning" })
    ejecutar("crear", { idOrdenServicio, idManoObra: servicio.idManoObra })
  }
  return <Vista><div style={{ width: "100%", padding: 24 }}>
    <h2 style={{ textAlign: "center", color: "#157CC1" }}>Manos de obra</h2>
    <Paper style={{ padding: 20, marginBottom: 20 }}><Grid container spacing={2} alignItems="end">
      <Grid item xs={12} md={9}><AutocompleteDeluxe nombre="manos-obra" dato={servicio} setDato={setServicio} labelToShow="Servicio" labelProp="descripcion" concat="codigo" idProp="idManoObra" required="true" /></Grid>
      <Grid item xs={12} md={3}><LoadingButton fullWidth variant="contained" loading={loading} onClick={crear}>AGREGAR SERVICIO</LoadingButton></Grid>
    </Grid></Paper>
    <Paper><TableContainer><Table size="small"><TableHead><TableRow>
      <TableCell>Código</TableCell><TableCell>Servicio</TableCell>
    </TableRow></TableHead><TableBody>{tareas.map(t => <TableRow key={t.idTareaOrdenServicio}>
      <TableCell>{t.codigoServicio}</TableCell>
      <TableCell>{t.descripcionServicio}</TableCell>
    </TableRow>)}{!tareas.length && <TableRow><TableCell colSpan={2} align="center">No hay servicios registrados.</TableCell></TableRow>}</TableBody></Table></TableContainer></Paper>
  </div></Vista>
}
export default ManoObra
